import React from "react";
import logo from "../assets/Logo.png";

export default function Navbar({ hideNavButtons = false }) {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav className="navbar">
      <div className="nav-left">
        <img src={logo} alt="PlantAChild logo" className="nav-logo" />
        <div className="nav-tagline">Never Late to Lend a Hand</div>
      </div>

      {!hideNavButtons && (
        <ul className="nav-menu">
          <li onClick={() => scrollTo("home")}>Home</li>
          <li onClick={() => scrollTo("impact")}>Our Impact</li>
          <li onClick={() => scrollTo("donate")}>Donate</li>
          <li onClick={() => scrollTo("about")}>About Us</li>
        </ul>
      )}
    </nav>
  );
}
